import { tasksTypes } from "../constantes/actionTypes"

const initialState = []

export const tasks = (state = initialState, action) => {
    
    switch (action.type) {
        case tasksTypes.GET_ALL_TASKS_SUCCESS:
            return action.payload
      case tasksTypes.GET_ALL_TASKS_BY_EVENT_PAGED_SUCCESS:
        return state.concat(action.payload)
      case tasksTypes.NEW_TASK_SUCCESS:
        return [...state, action.payload]
      case tasksTypes.UPDATE_TASK_SUCCESS:
        const updateTask = state.map(x => {
          if (x.id_CRM === action.payload.id_CRM)
            return action.payload
          return x
        })
        return updateTask
      case tasksTypes.DELETE_TASK_SUCCESS:
        return state.filter(x => x.id_CRM !== action.payload)
      case tasksTypes.NEW_TASK_FAILURE:
      case tasksTypes.UPDATE_TASK_FAILURE:
      case tasksTypes.DELETE_TASK_FAILURE:
        return state
      case tasksTypes.CLEAR_TASKS_LIST:
      case tasksTypes.GET_ALL_TASKS_BY_EVENT_PAGED_FAILURE:
        case tasksTypes.GET_ALL_TASKS_FAILURE:
            return initialState
        default:
            return state
    }
}